let hasRunForThreeGlobal = false;
let hasRunForFourGlobal = false;
const drawer = document.querySelector('#offerDrawer');
const drawerAddBtn = drawer?.querySelector('#drawerAddToCart');
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.addToCartBtn = this.querySelector(".quick-add__submit") || this.querySelector(".product-form__submit");
      this.collectionId = this.dataset.collectionId;
      this.affiliateProduct = this.dataset.affiliateProduct;
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.quiz = document.querySelector("product-quiz");
      if (this.quiz) {
        this.quizPopup = this.quiz.querySelector(".quiz__popup-wrapper");
        this.quizForm = this.quiz.querySelector('.quiz__form');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.addToCartBtn) {
        this.addToCartBtn.classList.add("adding-to-cart");
      }
      
      fetch('/cart.json')
        .then(response => response.json())
        .then(cartData => {
          const inputElement = this.querySelector('form').querySelector('[name=id]').getAttribute('value');
          var variantIdToCheck = Number(inputElement);
          var matchingItems = cartData.items.filter(item => item.variant_id === variantIdToCheck);
          var totalQuantity = matchingItems.reduce((total, item) => total + item.quantity, 0);

          if (document.querySelector('quantity-message')) {
            setTimeout(() => {
              let confettiShooterCount = document.querySelector('quantity-message')?.querySelector('noscript').getAttribute('data-cart-count');   
              if (confettiShooterCount == 3 && hasRunForThreeGlobal == false) {
               hasRunForThreeGlobal = true;
                window.confettiShooter(); }
              // } else if (confettiShooterCount == 4 && hasRunForFourGlobal == false) {
              //   hasRunForFourGlobal = true;
              //   window.confettiShooter();
              // }
            }, 2000);
          }
     

          if (totalQuantity < 4) {
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
            this.handleErrorMessage();
    
            this.submitButton.setAttribute('aria-disabled', true);
    
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
    
            const formData = new FormData(this.form);
            const progressbarCount = parseInt(this.getAttribute("data-progressBar-count") || "0", 10);

            for (let i = 1; i <= progressbarCount; i++) {
              const attr = `data-special-product_${i}`;
              if (this.getAttribute(attr)) {
                formData.append(`properties[special-product_${i}]`, "true");
                break;
              }
            }
            
            if (this.affiliateProduct === "true") {
              formData.append("properties[affiliateProduct]", true);
            }
            
            if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
              formData.append("quantity", document.querySelector("product-info quantity-input input")?.value);
            }
            config.body = formData;
    
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description);
    
                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
    
                var event = new CustomEvent('product:added', {
                  detail: {
                    response: response,
                    sectionTitle: this.dataset.sectionTitle,
                    blockTitle: this.dataset.blockTitle,
                    collectionName: this.dataset.collectionName
                  }
                });
                document.dispatchEvent(event);

                if (this.quiz) {
                  this.quiz.resetQuiz();
                  this.quizForm.reset();
                }

                if (this.quizPopup) {
                  document.querySelector('body').classList.remove('no-scroll');
                  this.quizPopup.classList.add('hidden');
                }
    
                if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form'
                });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => {
                      this.cart.renderContents(response)
                    });
                  }, {
                    once: true
                  });
                  quickAddModal.hide(true);
                } else if(this.getAttribute("data-isPreOrder") == "true"){
                  console.log("hello world");
                  this.postPreeOrderSubmit();
                  this.submitPreeOrder();
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    this.cart.addFreebie();
                  }, 4500);    
                } else {
                  this.cart.renderContents(response);
                  this.cart.addFreebie();

                  // Trigger Upsell Drawer Once Per Product Per Session (for forms with data-enable-upsell)                  
                  if (this.dataset.enableUpsell === "true" && !sessionStorage.getItem('upsellShownOnce')) {
                    if (drawer) {
                      drawer.classList.add('active');
                      if (drawerAddBtn) drawerAddBtn.textContent = "GO TO CART";
                    }
                    sessionStorage.setItem('upsellShownOnce', 'true');
                  }

                  let collectionProgressbar = document.querySelector("collection-progressbar");
                  if(collectionProgressbar){
                    collectionProgressbar.updateProgressBar();  
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                if (this.addToCartBtn) {
                  this.addToCartBtn.classList.remove("adding-to-cart");
                }
              });
          } else {
            if (this.addToCartBtn) {
              this.addToCartBtn.classList.remove("adding-to-cart");
            }
            alert(`Kindly Contact our customer Support team on WhatsApp at +91-9004436043 for bulk buying. Thank you`);
          }
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async submitPreeOrder() {

      const preorderData = {
        'Name': window.customerName || '',
        'Email': window.customerEmail || '',
        'Phone Number': window.customerPhone || '',
        'Product Title': this.getAttribute("data-product-title") || '',
        'Product ID': this.getAttribute("data-productId") || '',
        'Variant ID': this.getAttribute("data-variantId") || '',
        'SKU ID': this.getAttribute("data-skuId") || '',
        'Date Of Interaction': this.getAttribute("data-interaction-date") || ''
      };
        
      try {
        const formData = new FormData();
    
        Object.entries(preorderData).forEach(([key, value]) => {
          formData.append(key, value);
        });
    
        // adding form data in excel sheet
        const response = await fetch('https://script.google.com/macros/s/AKfycbyYXR8i1PNnOKRJJ-vQbvHtr4WPnO305qlYMQKkdPkpQ9oQ3hiZr6TRfMspuOpRVn0N3Q/exec',
          {
            method: 'POST',
            body: formData,
          }
        );
    
        if (response.ok) {
          console.log("Form submitted successfully");
        } else {
          console.log('Failed to submit the form. Please try again.');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    } 
    
    postPreeOrderSubmit(){
      let cartSummery = document.querySelector('.quantity-message-bottom-container');
      const successMessage = document.querySelector('.preorder-me-success-message-popup');
      successMessage.classList.remove("inactive");

      if(cartSummery){
       cartSummery.classList.add("hidden");
      }

      setTimeout(() => {
        successMessage.classList.add("inactive");
        if(cartSummery){
          cartSummery.classList.remove("hidden");
        }
      }, 4000);

      let clevertapData = {
        Product_Name: this.getAttribute("data-product-title") || '',
        Product_id: this.getAttribute("data-productId") || '',
        Variant_id: this.getAttribute("data-variantId") || '',
        Qty: document.querySelector(".quantity__input") ? document.querySelector(".quantity__input").value : '1',
        SKU: this.getAttribute("data-skuId") || '',
        Product_Link:this.getAttribute("data-product-link") || '',
        Date_Ordered: this.getAttribute("data-interaction-date") || '',
        Cart_Value:document.querySelector(".cart-discounted-price").innerHTML || ''
      }

      dataLayer.push({
        event: "Pre-Order",
        Product_Name: this.getAttribute("data-product-title") || '',
        Product_id: this.getAttribute("data-productId") || '',
        Variant_id: this.getAttribute("data-variantId") || '',
        Qty: document.querySelector(".quantity__input") ? document.querySelector(".quantity__input").value : '1',
        SKU: this.getAttribute("data-skuId") || '',
        Product_Link:this.getAttribute("data-product-link") || '',
        Date_Ordered: this.getAttribute("data-interaction-date") || '',
        Cart_Value:document.querySelector(".cart-discounted-price").innerHTML || '',
        clevertap : clevertapData
      });
    }
  });
}

